import { render, staticRenderFns } from "./CommercialProductForm.vue?vue&type=template&id=27bb7c34&scoped=true&"
import script from "./CommercialProductForm.vue?vue&type=script&lang=js&"
export * from "./CommercialProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb7c34",
  null
  
)

export default component.exports